import React, { useCallback } from 'react';
import useLocale from '@/hooks/useLocale';
import * as Styles from './ProductTemplateAbout.styles';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { IconArrow } from 'gatorcomponents';
import ContentSection from '@/pages/Products/VpsOciDetailPage/components/ContentSection';
import { useHistory } from 'react-router';
import { locale } from '@/utils/locale';

const ProductTemplateAbout = () => {
  const history = useHistory();
  const vpsOci = useSelector(state => state.vpsOci);
  const { vps } = (vpsOci && vpsOci.data) || {};

  const { productDetails: productDetailsLocale } = useLocale();
  const { store: localeStore } = productDetailsLocale.vpsOci;

  const { id: productId } = useParams();

  const handleBackButtonClick = useCallback(() => {
    history.push(`${locale('routes.products')}${locale('routes.productdetail')}/${productId}`);
  }, [history, productId]);

  if (!vps || Object.keys(vps).length === 0) return null;

  return (
    <ContentSection
      direction="row"
      align="flex-start"
      justify="flex-start"
      testId="vpsoci-templates-about-section"
    >
      <Styles.TitleWrapper>
        <Styles.BackButton onClick={() => handleBackButtonClick()} data-testid="vpsoci-templates-page-back-button">
          <IconArrow
            size="lg"
            color="lowDark"
            testId="vpsoci-templates-page-back-button-icon"
            direction="left"
          />
        </Styles.BackButton>
        <Styles.Content>
          <Styles.Title data-testid="vpsoci-templates-about-title">{localeStore.details.title}</Styles.Title>
          <Styles.Description data-testid="vpsoci-templates-about-description">{localeStore.details.description}</Styles.Description>
        </Styles.Content>
      </Styles.TitleWrapper>
    </ContentSection>
  );
};

export default ProductTemplateAbout;
